import React from "react";
import { Backdrop, Box, CircularProgress } from "@mui/material";

export function PageLoader({ open = false }) {
    return (
        <Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
            <CircularProgress color="inherit" />
        </Backdrop>
    );
}

export function BlockLoader() {
    return (
        <Box
            sx={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "100%",
                minHeight: "70px",
                minWidth: "70px",
            }}
        >
            <CircularProgress color="inherit" />
        </Box>
    );
}
